module.exports = __webpack_public_path__ + "v4assets/perf-monitor-interconnects.83b29cf17e65edda4ae1b66b43565a5f.png";